import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m2.4 6 4.3-4.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5 5c-.4.4-.4 1 0 1.4l5 5c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4zm7 0 4.3-4.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5 5c-.4.4-.4 1 0 1.4l5 5c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4z"
    }, null, -1)
  ]))]))
}
export default { render: render }